import instance from './axiosInstance';

const routerPrefix = '/notification-channel';

export const fetchWebhooksList = async ({ context = 'app' }) => {
  return instance(`${routerPrefix}/webhooks/list?context=${context}`);
};

export const createWebhook = async (payload) => {
  return instance.post(`${routerPrefix}/webhooks/config`, {
    configuration: payload,
  });
};

export const editWebhook = async ({ id, payload }) => {
  return instance.post(`${routerPrefix}/webhooks/config/${id}`, {
    configuration: payload,
  });
};

export const verifyWebhook = async (payload) => {
  return instance.post(`${routerPrefix}/webhooks/verify`, {
    ...payload,
  });
};

export const fetchWebhook = async (id) => {
  return instance.get(`${routerPrefix}/webhooks/config/${id}`);
};

export const deleteWebhook = async ({ id }) => {
  return instance.delete(`${routerPrefix}/webhooks/config/${id}`);
};

export const updateWebhookStatus = async ({ id, status }) => {
  return instance.put(`${routerPrefix}/webhooks/status/${id}`, { status });
};

export const fetchWebhookChangeHistoryLogs = async ({ id }) => {
  return instance.post(`${routerPrefix}/webhooks/history-log/${id}`);
};
